import React from "react";

const SimpleSpacerLine = ({ height = "1px", color = "#ccc", margin = "16px 0" }) => {
    return (
        <div
            style={{
                height,
                backgroundColor: color,
                width: "100%",
                margin,
            }}
        />
    );
};

export default SimpleSpacerLine;
